import { useMemo } from 'react';

import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { formatDate, onError } from 'src/utils/utils';

import { CheckInCallSetupTableProps } from '../types';

import { navigate } from '@redwoodjs/router';
import { useMutation } from '@redwoodjs/web';
import { showSuccessToast } from 'src/components/Toasts/toast';
import { DELETE_CHECK_IN_CALL } from 'src/graphql/mutations/addCheckInCall.mutation';
import CheckInCallSetupGridColDef from './CheckInCallSetupGridColDef';

export const CheckInCallSetupTable = ({
    handleAddCheckInCall,
    loading,
    data,
    refetch,
}: CheckInCallSetupTableProps) => {
    const [deleteCheckInCall] = useMutation(DELETE_CHECK_IN_CALL, {
        onCompleted: (data) => {
            if (data?.deleteCheckInCall?.success) {
                showSuccessToast(data?.deleteCheckInCall?.message);
                refetch();
            }
        },
        onError,
    });

    const handleEdit = (rowId: number) => {
        navigate(`/config/check-in-call-view/${rowId}`);
    };

    const handleView = (rowId: number) => {
        navigate(`/config/check-in-call-view/${rowId}&view=true`);
    };

    const handleDelete = (rowId: number) => {
        deleteCheckInCall({ variables: { id: rowId } });
    };

    const tableData = useMemo(() => {
        const result =
            [...data]?.map((checkIn) => {
                const { id, createdAt, callType, callName } = checkIn;
                return {
                    id,
                    callName,
                    callType,
                    createdAt: formatDate({ date: createdAt }),
                };
            }) ?? [];

        return {
            rows: result,
        };
    }, [data]);

    return (
        <>
            {loading || !data ? (
                <Loader />
            ) : (
                <NPIDataGrid
                    rows={tableData.rows}
                    columns={CheckInCallSetupGridColDef(handleEdit, handleView, handleDelete)}
                    getRowId={(row) => {
                        return row.id;
                    }}
                    title="Check-in Call Setup"
                    addRecordButtonConfig={{
                        addRecordButtonText: 'Add Check-in Call',
                        addRecordCallBack: handleAddCheckInCall,
                    }}
                    dataTestId="check-in-call-setup-table"
                />
            )}
        </>
    );
};

export default CheckInCallSetupTable;
